<span
  *ngIf="decorative"
  class="icon-action-btn"
  [class.icon-action-btn--circle]="shape === 'circle'"
  [class.icon-action-btn--brand]="tone === 'brand'"
  [class.icon-action-btn--danger]="tone === 'danger'"
  [class.icon-action-btn--neutral]="tone === 'neutral'"
  [attr.aria-label]="ariaLabel || title || null"
  [ngbTooltip]="tooltip || null"
  [disableTooltip]="!tooltip"
  tooltipClass="tooltip-4"
  placement="bottom"
  container="body"
  role="img"
>
  <i [class]="'bi ' + icon" aria-hidden="true"></i>
</span>

<button
  *ngIf="!decorative"
  type="button"
  class="icon-action-btn"
  [class.icon-action-btn--circle]="shape === 'circle'"
  [class.icon-action-btn--brand]="tone === 'brand'"
  [class.icon-action-btn--danger]="tone === 'danger'"
  [class.icon-action-btn--neutral]="tone === 'neutral'"
  [attr.aria-label]="ariaLabel || title || null"
  [attr.title]="tooltip ? null : (title || null)"
  [ngbTooltip]="tooltip || null"
  [disableTooltip]="!tooltip"
  tooltipClass="tooltip-4"
  placement="bottom"
  container="body"
  (click)="onClick($event)"
>
  <i [class]="'bi ' + icon" aria-hidden="true"></i>
</button>
